import React from "react";
import { Form } from "react-bootstrap";
import { useSelector } from "react-redux";

function StateView(props) {
  const CropsValue = useSelector((state) => state.field.crops);

  const getCropTypes = () => {
    const cropTypes = CropsValue;
    const crops = cropTypes.map((crop) => (
      <option key={Math.random()} value={crop.id}>
        {crop.text}
      </option>
    ));

    return crops;
  };

  const crops = getCropTypes();
  return (
    <Form.Select
      size="sm"
      name="crop"
      value={props.cropName}
      required
      onChange={props.handleCropNameChange(props.index)}
      disabled={props.Disabled}
    >
      {crops}
    </Form.Select>
  );
}

export default StateView;
